import { render, staticRenderFns } from "./customer_allocation.vue?vue&type=template&id=928029e0&"
import script from "./customer_allocation.vue?vue&type=script&lang=js&"
export * from "./customer_allocation.vue?vue&type=script&lang=js&"
import style0 from "./customer_allocation.vue?vue&type=style&index=0&id=928029e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports